import { CHOWNOW } from 'constants/integrations';

export function useIntegrationFieldsVisibility(menu) {
  const menuIntegrations = menu?.integrations || [];

  return menuIntegrations.some(
    integration => integration.integrationName.toUpperCase() !== CHOWNOW,
  );
}
